<template>
  <div
    class="sticked_search"
    :class="$store.state.user.darkMode ? 'background-dark' : 'background-light'"
  >
    <div style="position: relative" class="text-center mb-0 px-2 py-1 mt-2">
      <v-btn
        text
        class="text-transform-initial"
        v-if="$store.state.active_parent.id != 0"
        :to="'/bookmarks/' + $store.state.active_parent.parent"
      >
        <strong>../</strong>
      </v-btn>

      <v-btn
        text
        class="text-transform-initial"
        @click="$store.commit('updateStateVariable', { drawer: true })"
        style="max-width:40vw;"
      >
        <v-icon class="mr-2 " color="primary">{{
          $store.state.active_parent.hidden ? "mdi-folder-lock" : "mdi-folder"
        }}</v-icon>
        <span class="font-weight-bold text-truncate" style="width: 100%;">
          {{ $store.state.active_parent.label }}
        </span>
      </v-btn>

      <v-btn
        icon
        class="mx-2"
        v-if="$store.state.active_parent.id != 0"
        :loading="$store.state.loading_favorite"
        @click="$store.dispatch('toggleFavorite')"
      >
        <v-icon color="primary">
          <!-- prettier-ignore -->
          {{parent_favorite ? "mdi-star" : "mdi-star-outline"}}
        </v-icon>
      </v-btn>

      <v-dialog width="500" v-model="modal_help" scrollable>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon color="grey">mdi-help-circle-outline</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="justify-center">
            Common Actions
          </v-card-title>

          <v-card-text class="customScroll">
            <v-subheader class="text-overline primary--text ml-0 pl-0">CREATE</v-subheader>
            <!-- prettier-ignore -->
            <p>
              Click <v-icon small color="primary" class="mx-1">mdi-link-variant-plus</v-icon> or <v-icon small color="primary" class="mx-1">mdi-folder-plus-outline</v-icon> buttons to add URL and Folders.
            </p>
            <p class="text-justify">
              Drag & drop below bookmarklet button to your browser's bookmarks bar for a
              one-click-add-url button. For mobile browsers, create a bookmark and copy paste below
              Quick-Add Address for a one-click-add-url button.
            </p>
            <div class="text-center">
              <Bookmarklet small />
            </div>

            <v-subheader class="text-overline primary--text ml-0 pl-0">ORDER</v-subheader>
            <!-- prettier-ignore -->
            <p>
              Drag from URL and Folder <strong>icons (<v-icon small color="primary" class="mx-1">mdi-folder</v-icon>, <v-img style="position:relative; top: 2px;" class="d-inline-block" max-width="13" max-height="13" rounded src="https://www.google.com/s2/favicons?domain=www.google.com"></v-img> etc.)</strong> to order your lists.
            </p>
            <v-subheader class="text-overline primary--text ml-0 pl-0">UPDATE</v-subheader>
            <!-- prettier-ignore -->
            <p>
              Click <v-icon small color="primary" class="mx-1">mdi-pencil</v-icon> and click on the <strong>Name</strong> of the URL or Folder you want to edit.
            </p>
            <v-subheader class="text-overline primary--text ml-0 pl-0">DELETE</v-subheader>
            <!-- prettier-ignore -->
            <p>
              Click <v-icon small color="primary" class="mx-1">mdi-pencil</v-icon> and select as many URLs or Folders as you want. Afterwards, click on <v-icon small color="primary" class="mx-1">mdi-delete-outline</v-icon> to delete.
            </p>
            <v-subheader class="text-overline primary--text ml-0 pl-0">MOVE</v-subheader>
            <!-- prettier-ignore -->
            <p>
              Click <v-icon small color="primary" class="mx-1">mdi-pencil</v-icon> and select as many URLs or Folders as you want. Afterwards, click on <v-icon small color="primary" class="mx-1">mdi-folder-upload-outline</v-icon> and select your target folder to move the items.
            </p>
            <p>
              You can also drag-drop files on folders on the main list or on the left-side menu
              (only on desktop)
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modal_help = false">CLOSE</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <span v-on="on">
            <v-btn
              icon
              :color="$store.state.lock.unlocked ? 'success' : 'grey'"
              class="mx-1"
              v-bind="attrs"
              v-on="on"
              @click="$store.commit('updateStateLock', { modal: true })"
            >
              <v-icon>{{
                $store.state.lock.unlocked ? "mdi-lock-open-outline" : "mdi-lock-outline"
              }}</v-icon>
            </v-btn>
          </span>
        </template>
        <span>Unlock</span>
      </v-tooltip>
    </div>

    <div class="pb-2 d-flex justify-space-between align-stretch">
      <div v-show="!edit_mode">
        <v-btn text color="primary" class="mr-1" @click="$store.dispatch('clickAddURL')">
          <v-icon class="mr-2">mdi-link-variant-plus</v-icon>
          URL
        </v-btn>

        <v-btn text color="primary" class="mr-1" @click="$store.dispatch('clickAddFolder')">
          <v-icon class="mr-2">mdi-folder-plus-outline</v-icon>
          Folder
        </v-btn>
      </div>
      <div class="d-flex justify-space-between align-stretch flex-grow-1">
        <div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on">
                <v-btn
                  icon
                  v-if="edit_mode"
                  color="primary"
                  class="mx-1"
                  :disabled="$store.getters.allSelected"
                  v-bind="attrs"
                  v-on="on"
                  @click="$store.commit('selectAll', true)"
                >
                  <v-icon>mdi-checkbox-multiple-marked-outline</v-icon>
                </v-btn>
              </span>
            </template>
            <span>Select All</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on">
                <v-btn
                  icon
                  v-if="edit_mode"
                  color="primary"
                  class="mx-1"
                  :disabled="!$store.getters.anySelected"
                  v-bind="attrs"
                  v-on="on"
                  @click="$store.commit('selectAll', false)"
                >
                  <v-icon>mdi-checkbox-multiple-blank-outline</v-icon>
                </v-btn>
              </span>
            </template>
            <span>Unselect All</span>
          </v-tooltip>

          <v-tooltip bottom v-if="edit_mode">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                class="mx-1"
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="edit_mode = false"
              >
                CLOSE
              </v-btn>
            </template>
            <span>(E)</span>
          </v-tooltip>
        </div>
        <div>
          <v-tooltip bottom v-if="!edit_mode">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                class="mx-1"
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="openEditMode"
              >
                <v-icon color="primary">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit (E)</span>
          </v-tooltip>

          <v-tooltip bottom v-if="!edit_mode">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                class="mx-1"
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="$store.dispatch('openAll', { checkCount: true })"
              >
                <v-icon color="primary">mdi-open-in-new</v-icon>
              </v-btn>
            </template>
            <span>Open Links (O)</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on">
                <v-btn
                  icon
                  color="primary"
                  v-if="edit_mode"
                  class="mx-1"
                  :disabled="!$store.getters.anySelected"
                  v-bind="attrs"
                  v-on="on"
                  @click="clickCopy"
                >
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </span>
            </template>
            <span>Copy</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on">
                <v-btn
                  icon
                  color="primary"
                  v-if="edit_mode"
                  class="mx-1"
                  :disabled="!$store.getters.anySelected"
                  v-bind="attrs"
                  v-on="on"
                  @click="$store.dispatch('clickMove', true)"
                >
                  <v-icon>mdi-folder-upload-outline</v-icon>
                </v-btn>
              </span>
            </template>
            <span>Move</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on" v-bind="attrs">
                <v-btn
                  icon
                  v-if="edit_mode"
                  color="error"
                  class="mr-1 ml-1"
                  :disabled="!$store.getters.anySelected"
                  @click="$store.dispatch('clickDelete')"
                >
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </span>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bookmarklet from "./Bookmarklet";

export default {
  name: "GlobalActions",
  components: { Bookmarklet },
  data() {
    return {
      modal_help: false,
    };
  },
  computed: {
    edit_mode: {
      get() {
        return this.$store.state.edit_mode;
      },
      set(value) {
        this.$store.commit("updateStateVariable", { edit_mode: value });
      },
    },
    parent_favorite: {
      get() {
        return this.$store.state.bookmarks[this.$store.state.active_parent.id].favorite;
      },
    },
    selectedLayout: {
      get() {
        return this.$store.state.user.selectedLayout;
      },
      set(value) {
        this.$store.commit("updateStateUser", { selectedLayout: value });
      },
    },
  },
  methods: {
    clickImport() {
      this.$refs.file_upload.click();
    },
    onImportFileChanged() {
      let file = this.$refs.file_upload.files[0];
      console.log(file, "file");
      console.log(file.type, "file.type");
      // if (!file || file.type !== "application/json") {
      //   return this.error("Not a JSON file!");
      // }

      let reader = new FileReader();
      reader.readAsText(file, "UTF-8");

      reader.onerror = (e) => {
        console.error(e);
        return this.error(e.message);
      };

      reader.onload = (evt) => {
        console.log(evt.target.result, "evt.target.result");
        // let json = JSON.parse(evt.target.result);
        // console.log(json, "file contents");

        this.$store.commit("updateStateVariable", {
          snackbar: {
            open: true,
            html: "Imported",
            icon: "success",
            timeout: 5000,
            action: "close",
          },
        });
        // if we dont do this it will not trigger if same file is selected twice
        this.$refs.file_upload.value = "";
      };
    },
    openEditMode() {
      this.$store.commit("selectAll", false);
      this.edit_mode = true;
    },
    clickCopy() {
      const selected_links = this.$store.getters.selected_items.filter((v) => v.type == "url");

      if (selected_links.length == 0) {
        this.$store.commit("updateStateSnackbar", {
          open: true,
          html: "No URL selected!",
          icon: "error",
          timeout: 2000,
          action: "close",
        });
        return;
      } else if (selected_links.length == 1) {
        // single item selected copy URL > note > label
        let item = selected_links[0];
        let tobecopied = "";
        let message = "";
        if (item.url !== null && item.url !== "") {
          tobecopied = item.url;
          message = "URL Copied!";
        } else if (item.note !== null && item.note !== "") {
          tobecopied = item.note;
          message = "Note Copied!";
        } else if (item.label !== null && item.label !== "") {
          tobecopied = item.label;
          message = "Label Copied!";
        }
        this.$store.dispatch("copy", { text: tobecopied, message: message });
        // this.copy(tobecopied, message);
      } else {
        // multiple items selected
        let text = "";
        selected_links.forEach((g) => {
          text += `-----------------------------------\n\n`;
          if (g.label !== null && g.label !== "") {
            text += `Label:\n${g.label}:\n\n`;
          }
          if (g.url !== null && g.url !== "") {
            text += `URL:\n${g.url}\n\n`;
          }
          // prettier-ignore
          if (typeof g.note !== "undefined" && g.note !== null && g.note !== "") {
            text += `Note:\n${g.note}\n\n`;
          }
        });
        this.$store.dispatch("copy", { text: text, message: "Multiple items copied!" });
        // this.copy(text);
      }
    },
    // copy(text, message) {
    //   this.$copyText(text).then(
    //     (e) => {
    //       this.$store.commit("updateStateSnackbar", {
    //         open: true,
    //         html: message || "Copied!",
    //         icon: "success",
    //         timeout: 2000,
    //         action: "close",
    //       });
    //     },
    //     (e) => {
    //       this.$store.commit("updateStateSnackbar", {
    //         open: true,
    //         html: "There is a problem!",
    //         icon: "error",
    //         timeout: 2000,
    //         action: "close",
    //       });
    //     }
    //   );
    // },
  },
};
</script>

<style>
.sticked_search {
  z-index: 1;
  position: sticky;
  position: -webkit-sticky;
  top: 45px;
}
.background-dark {
  background-color: #121212f5;
}
.background-light {
  background-color: #fffffff3;
}
</style>
